/**
 * Progreso de aprobación del PROPIO alumno en una cohorte (M1). Lee el estado
 * server-authoritative (`/api/cohorts/:id/my-completion`) y muestra chips por
 * criterio ("Asistencia 80% ✓ · 3/4 desafíos · Proyecto final ✗").
 */
import { type Component, createResource, For, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { completionChips } from "@space/shared";

import { useI18n } from "@/providers/i18n-provider";
import { fetchMyCompletion } from "./api";

export const CompletionProgress: Component<{ cohortId: string }> = (props) => {
  const { t } = useI18n();
  // Errores (p.ej. aún no calificado / no activo) → simplemente no se muestra.
  const [status] = createResource(
    () => props.cohortId,
    async (id) => fetchMyCompletion(id).catch(() => null),
  );

  return (
    <Show when={status()}>
      {(s) => (
        <div class="flex flex-wrap items-center gap-1.5 text-xs" data-testid="my-completion">
          <span
            class={s().passed ? "font-medium text-success" : "text-muted-foreground"}
            data-testid="my-completion-passed"
            data-passed={s().passed ? "true" : "false"}
          >
            {s().passed ? t(msg`Requirements met`) : t(msg`In progress`)}
          </span>
          <For each={completionChips(s())}>
            {(chip) => (
              <span
                class={`rounded px-1.5 py-0.5 ${
                  chip.met ? "bg-success/15 text-success" : "bg-muted text-muted-foreground"
                }`}
                data-testid={`my-completion-chip-${chip.key}`}
              >
                {chip.shortLabel} {chip.progress} {chip.met ? "✓" : "✗"}
              </span>
            )}
          </For>
        </div>
      )}
    </Show>
  );
};
